import httpService from "./httpService";

const AttendanceServices = {
  // Clock In
  clockIn: async (employeeId, storeId) => {
    const response = await httpService.post("/api/attendance/clock-in", {
      employeeId,
      storeId,
    });
    return response;
  },

  // Clock Out
  clockOut: async (employeeId, storeId) => {
    const response = await httpService.post("/api/attendance/clock-out", {
      employeeId,
      storeId,
    });
    return response;
  },

  // Get Today's Status
  getTodayStatus: async (employeeId, storeId) => {
    const params = storeId ? `?storeId=${storeId}` : "";
    const response = await httpService.get(
      `/api/attendance/today-status/${employeeId}${params}`
    );
    return response;
  },

  // Get Employee Attendance
  getEmployeeAttendance: async (employeeId, storeId, params = {}) => {
    const queryParams = new URLSearchParams({
      ...params,
      ...(storeId && { storeId }),
    }).toString();
    const response = await httpService.get(
      `/api/attendance/employee/${employeeId}${
        queryParams ? `?${queryParams}` : ""
      }`
    );
    return response;
  },

  // Get All Employees Attendance
  getAllEmployeesAttendance: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const response = await httpService.get(
      `/api/attendance/all${queryParams ? `?${queryParams}` : ""}`
    );
    return response;
  },

  // Create Manual Attendance
  createManualAttendance: async (attendanceData, storeId) => {
    const response = await httpService.post("/api/attendance/manual", {
      ...attendanceData,
      storeId,
    });
    return response;
  },

  // Update Attendance
  updateAttendance: async (attendanceId, updateData, storeId) => {
    const response = await httpService.put(`/api/attendance/${attendanceId}`, {
      ...updateData,
      storeId,
    });
    return response;
  },

  // Delete Attendance
  deleteAttendance: async (attendanceId, storeId) => {
    const queryParams = storeId ? `?storeId=${storeId}` : "";
    const response = await httpService.delete(
      `/api/attendance/${attendanceId}${queryParams}`
    );
    return response;
  },
};

export default AttendanceServices;
